module.exports = __webpack_public_path__ + "img/mastermind.91ffd4fd.png";